<template>
  <v-card :loading="loading" :disabled="loading">
    <CardTitle :title="title ? 'Licenses: '+ title : 'Licenses'">
      <template v-slot:prepend_actions>
        <License :customer_id="customer_id"></License>
      </template>
      <template v-slot:actions>
        <slot name="title_actions"></slot>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
          </template>
          <span>Reload Data</span>
        </v-tooltip>
      </template>
    </CardTitle>
    <v-card-text :class="dialog ? '' : 'overflow-y-auto'" :style="dialog ? '' : 'height:250px'">
        <v-list dense>
          <template v-for="(item,index) in items">
            <v-list-item :key="item.id">
              <v-list-item-content>
                <v-list-item-subtitle>Type</v-list-item-subtitle>
                <v-list-item-title>{{item.license_type ? item.license_type.desc : 'License Type Doesn\'t exist'}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-subtitle>License</v-list-item-subtitle>
                <v-list-item-title>{{item.license}}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <License editing :customer_id="customer_id" :data="item"></License>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index+1 !== items.length" :key="`${index}-${item.id}`"></v-divider>
          </template>
        </v-list>
    </v-card-text>
    <slot name="actions"></slot>
  </v-card>
</template>

<script>
export default {
name: "Licenses",
  components:{
    License: () => import("@/views/DirectoryV2/components/forms/License")
  },
  data: () => ({
    loading: false,
  }),
  props:{
    customer_id: {
      required: true,
    },
    title:{
      required: false,
    },
    dialog: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    items(){
      return this.$store.$db().model('licenses').query().where('customer_id', this.customer_id).with('license_type').all();
    }
  },
  watch:{
    customer_id(){
      if(!this.loading){
        this.loadData();
      }
    }
  },
  mounted(){
    if(!this.loading){
      this.loadData();
    }
  },
  methods:{
    async loadData(){
      this.extraData();
      this.loading = true;
      try{
        await this.$store.$db().model('licenses').api().fetch({
          where: {
            key: "customer_id",
            value: this.customer_id
          },
          with: 'licenseType'
        });
      }catch(err){
        this.$store.dispatch("showError", "Failed to load data.")
      } finally {
        this.loading = false;
      }
    },
    extraData(){
      this.$store.$db().model('licenseTypes').api().fetch();
    }
  }
}
</script>

<style scoped>

</style>
